import script from "./BootstrapControllerBridge.vue?vue&type=script&lang=js"
export * from "./BootstrapControllerBridge.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__